import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {ItemRequest} from '@store/item-requests/item-requests.types';
import {ItemRequestTitleComponent, MinimalCatalogRecord} from '@app/my-account/item-requests/table-column-components/item-request-title.component';
import {ItemRequestAuthorColumnComponent} from '@app/my-account/item-requests/table-column-components/item-request-author-column.component';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {ItemRequestsSelectors} from '@store/item-requests/item-requests.selectors';
import {FormatPipe} from '@aviary/pipes/format.pipe';

@Component({
  selector: 'px-combined-title-author-column',
  host: {
    class: 'text-wrap',
  },
  template: `
    @if ({
      isSm: viewportSelectors.isSm | select
    }; as vm) {
      <div class="flex flex-col">
        <px-item-request-title-column [itemRequest]="itemRequest" [catalogRecord]="catalogRecord"/>
        <px-item-request-author-column [itemRequest]="itemRequest"/>
        @if (vm.isSm) {
          <p>{{ selectors.createdFor(itemRequest) | select | format:'DATE_ONLY' }}</p>
        }
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ItemRequestTitleComponent, ItemRequestAuthorColumnComponent, FormatPipe, SelectPipe]
})
export class CombinedTitleAuthorColumnComponent {
  @Input({required: true}) public itemRequest: ItemRequest;
  @Input({required: true}) public catalogRecord: MinimalCatalogRecord;
  public readonly selectors = ItemRequestsSelectors.Stateless;
  public readonly viewportSelectors = ViewportSelectors;
}
